<template>
  <Vue3SlideUpDown
    v-if="hideOnOneTime"
    v-model="visible"
    :duration="slideDuration"
    class="product__subscription-perks__inner"
  >
    <slot />
  </Vue3SlideUpDown>
  <div
    v-else
    class="product__subscription-perks__inner"
  >
    <slot />
  </div>
</template>

<script>
import { Vue3SlideUpDown } from 'vue3-slide-up-down'
import { mapState } from 'pinia'
import { useProductStore } from '../../pinia/ProductStore'

export default {
  components: {
    Vue3SlideUpDown
  },
  inheritAttrs: false,
  data () {
    return {
      hydrationSettled: false,
      slideDuration: 300
    }
  },
  computed: {
    ...mapState(useProductStore, {
      subscriptionPerksVisible: 'subscriptionPerksVisible'
    }),
    hideOnOneTime () {
      const value = this.$attrs['data-hide-on-one-time']
      return value === 'true' || value === true
    },
    ssrVisible () {
      const value = this.$attrs['data-ssr-visible']
      return value === 'true' || value === true
    },
    visible () {
      if (!this.hideOnOneTime) return true
      if (this.subscriptionPerksVisible) return true
      if (this.ssrVisible && !this.hydrationSettled) return true
      return false
    }
  },
  watch: {
    subscriptionPerksVisible () {
      this.hydrationSettled = true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.hydrationSettled = true
    })
  }
}
</script>
